<template>
    <div>
        <!--<div :class="show ? 'slideinoverlay': ''" @click="show = false;"></div>-->
        <div class="c-sidebar c-sidebar-dark c-sidebar-fixed" :class="show ? ' c-sidebar-show' : ''">
            <div style="height:40px;">
                <div class="mobile-header">
                    <i class="fa fa-arrow-left" @click="toggleSidebar"></i>

                    <!--<i class="fa fa-settings" @click="bool_isAMV = false;"></i>-->
                    <!--<div class="mobile-title"> <h4 class="text-white font-weight-bold mb-0">{{this.getLanguage["MTA"]["WPM7"]}}</h4></div>-->
                </div>
            </div>
            <div class="" style="overflow-y: scroll; overflow-x: hidden;">
                <div class="form-section" style="background: #16171b; padding: 10px; color: #fff; margin-top: -1px; ">
                    <div class="d-flex align-items-center position-relative" style="gap:5px">
                        <div style=" background: #24262B; border-radius: 50%; width: 60px; height: 60px; justify-content: center; display: flex;" @click="bool_isProfile = true">
                            <img class="img-fluid" width="30" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/profile.svg" style="filter: drop-shadow(1px 1px 0px black);">
                        </div>

                        <div class="ml-2 ">
                            <strong style="font-size: 18px;">{{getUserInfo.DN}} ({{getUserInfo.PC}})</strong> <br />
                            <!--<span class="agentInfo">
        <span>{{getLanguage['BAL']['AT']}}</span>
        <span class="ml-2">{{getUserInfo.RN}}</span>
    </span>-->
                            <span class="agentInfo" v-if="obj_Group && obj_Group.SubAgentPayoutScheme">
                                <span> {{this.getLanguage['SAPS']['TYP']}}</span>
                                <span class="ml-2">
                                    <template v-for="item in constSubAgentType" v-if="obj_Group.SubAgentPayoutScheme.WLT == item.id">
                                        {{ utilGetErrorLanguage('SAPS.' + item.label) }}
                                    </template>
                                </span>
                            </span>
                            <span class="agentInfo" v-if="obj_Group && obj_Group.SubAgentPayoutScheme">
                                <span> {{this.getLanguage['SAPS']['PT']}}</span>
                                <span class="ml-2">
                                    {{ obj_Group.SubAgentPayoutScheme.PT }}%
                                </span>
                            </span>
                            <!--<span class="agentInfo">
                                <span> {{this.getLanguage['SMB']['SB']}}</span>
                                <span class="ml-2">
                                    {{ formatNumber(this.getSystemBalance, 2, this.getCurrencySymbol) }}
                                </span>
                            </span>-->
                            <span class="agentInfo" v-if="obj_P.LLTS">
                                <span>{{getLanguage['MEM']['LLT']}}</span>
                                <span class="ml-2"> {{ obj_P.LLTS | moment('DD MMM YYYY HH:mm:ss')}}</span>
                            </span>
                        </div>

                        <div style=" position: absolute; right: 10px; top: 50%; transform: translate(0%, -50%);">
                            <div class="pointer text-white text-capitalize align-items-center" @click="btnClick('Logout')">
                                <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/logout.svg" style="filter: drop-shadow(1px 1px 0px black);">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-section" style="background: #16171b; padding: 0px 10px 10px 10px; margin-top: 0; color: rgb(255, 255, 255);font-size:12px; ">
                    <div style="display: grid; gap: 5px; grid-template-columns: 1fr 1fr 1fr 1fr;">
                        <router-link :to="{ path:'/W/WDU', query:{ t: 1 }}" tag="a" class="text-white text-capitalize text-center" style="">
                            <div style="border: 1px solid rgb(249 249 249 / 28%); padding: 8px; background: #24262b; border-radius: 5px; ">
                                <!--<svg fill="#ffffff" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="icon" stroke="#ffffff" style="width: 20px; height: 20px; fill: #fff; filter: drop-shadow(1px 1px 0px black); margin-bottom: 5px !important;"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z"></path> </g></svg>-->
                                <img class="img-fluid d-block m-auto" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/total earning.svg" style="filter: drop-shadow(1px 1px 0px black);margin-bottom: 5px !important;">
                                <div>{{this.getLanguage['MEM']['TRANS']}}</div>
                            </div>
                        </router-link>
                        <router-link :to="{ path:'/W/WDU', query:{ t: 2 }}" tag="a" class="text-white text-capitalize text-center" style="">
                            <div style="border: 1px solid rgb(249 249 249 / 28%); padding: 8px; background: #24262b; border-radius: 5px; ">
                                <img class="img-fluid d-block m-auto" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/withdraw.svg" style="filter: drop-shadow(1px 1px 0px black);margin-bottom: 5px !important;">
                                <div>{{this.getLanguage['SMB']['W']}}</div>
                            </div>
                        </router-link>
                        <router-link :to="{ path:'/EARN/D', query:{ t: 3 }}" tag="a" class="text-white text-capitalize text-center" style="">
                            <div style="border: 1px solid rgb(249 249 249 / 28%); padding: 8px; background: #24262b; border-radius: 5px;">
                                <img class="img-fluid d-block m-auto" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_downile.svg" style="filter: drop-shadow(1px 1px 0px black); margin-bottom: 5px !important;">
                                <div><!--{{this.getLanguage['SMB']['REC']}}--> + {{this.getLanguage['DB']['DL']}}</div>
                            </div>
                        </router-link>
                        <router-link :to="{ path:'/EARN/M', query:{ t: 3 }}" tag="a" class="text-white text-capitalize text-center" style="">
                            <div style="border: 1px solid rgb(249 249 249 / 28%); padding: 8px; background: #24262b; border-radius: 5px;">
                                <img class="img-fluid d-block m-auto" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_downline.svg" style="filter: drop-shadow(1px 1px 0px black); margin-bottom: 5px !important;">
                                <div><!--{{this.getLanguage['SMB']['REC']}}-->  + {{this.getLanguage['DB']['M']}}</div>
                            </div>
                        </router-link>
                    </div>
                </div>

                <div class="form-section" style="background: #1c1e22; padding: 10px; margin-top: 8px; color: #fff; ">
                    <div style="height: 30px; display: flex; align-items: center; border-bottom: 1px solid; border-color: #c4c9d0;">
                        <h4 class="font-weight-bold" style=" background: -webkit-linear-gradient(186deg, rgb(255, 167, 0) 40%, rgb(255, 123, 0) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">{{this.getLanguage['DB']['DL']}} </h4>
                    </div>
                    <router-link :to="{ path:'/EARN/D', query:{ t: 1 }}" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
                        <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_details.svg" style="filter: drop-shadow(1px 1px 0px black);">
                        <span> {{getLanguage['GL']['D']}}</span>
                        <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
                    </router-link>
                    <router-link :to="{ path:'/EARN/D', query:{ t: 2 }}" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
                        <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/profitloss.svg" style="filter: drop-shadow(1px 1px 0px black);">
                        <span> {{this.getLanguage['SMB']['RS3']}}</span>
                        <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
                    </router-link>
                    <!--<router-link to="/QR/DQR" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
             <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/QR CODE.svg" style="filter: drop-shadow(1px 1px 0px black);">
             <span>{{this.getLanguage['SMB']['REC']}} {{this.getLanguage['DB']['DL']}}</span>
             <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
        </router-link>-->
                </div>

                <div class="form-section" style="background: #1c1e22; padding: 10px; margin-top: 8px; color: #fff; ">
                    <div style="height: 30px; display: flex; align-items: center; border-bottom: 1px solid; border-color: #c4c9d0;">
                        <h4 class="font-weight-bold" style=" background: -webkit-linear-gradient(186deg, rgb(255, 167, 0) 40%, rgb(255, 123, 0) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">{{this.getLanguage['SMB']['M']}}</h4>
                    </div>

                    <router-link :to="{ path:'/EARN/M', query:{ t: 1 }}" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
                        <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_details.svg" style="filter: drop-shadow(1px 1px 0px black);">
                        <span>{{getLanguage['GL']['D']}}</span>
                        <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
                    </router-link>
                    <router-link :to="{ path:'/EARN/M', query:{ t: 2 }}" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
                        <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/profitloss.svg" style="filter: drop-shadow(1px 1px 0px black);">
                        <span>{{this.getLanguage['SMB']['RS3']}}</span>
                        <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
                    </router-link>
                    <router-link :to="{ path:'/EARN/M', query:{ t: 4 }}" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
                        <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/qrcode.svg" style="filter: drop-shadow(1px 1px 0px black);">
                        <span> + {{this.getLanguage['BAL']['QRUR']}}</span>
                        <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
                    </router-link>
                    <!--<router-link to="/QR/MQR" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
        <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/QR CODE.svg" style="filter: drop-shadow(1px 1px 0px black);">
        <span>{{this.getLanguage['SMB']['REC']}} {{this.getLanguage['DB']['M']}}</span>
        <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
    </router-link>-->
                </div>

                <div class="form-section" style="background: #1c1e22; padding: 10px; margin-top: 8px; color: #fff;">
                    <div style="height: 30px; display: flex; align-items: center; border-bottom: 1px solid; border-color: #c4c9d0;">
                        <h4 class="font-weight-bold" style=" background: -webkit-linear-gradient(186deg, rgb(255, 167, 0) 40%, rgb(255, 123, 0) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">{{getLanguage['ACT']['CSUPPORT']}}</h4>
                    </div>
                    <router-link to="/S/S" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
                        <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/support.svg" style="filter: drop-shadow(1px 1px 0px black);">
                        <span>{{getLanguage['SMB']['SUPPORT']}}</span>
                        <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
                    </router-link>
                    <router-link to="/TNC" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
                        <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/t&c.svg" style="filter: drop-shadow(1px 1px 0px black);">
                        <span>{{getLanguage['SMB']['TNC']}}</span>
                        <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
                    </router-link>
                    <!--<router-link to="/GUIDE" tag="a" class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;">
                        <i class="fa-solid fa-book" style="filter: drop-shadow(1px 1px 0px black); font-size: 20px;"></i>
                        <span>User Manual</span>
                        <i class="fa fa-arrow-right text-right" style="font-size:10px !important;color:#808488"></i>
                    </router-link>-->
                    <div class="text-white text-capitalize align-items-center" style="gap: 5px; height: 35px; display: grid !important; grid-template-columns: 25px 200px auto;" @click="clickAbout()">
                        <img class="img-fluid" width="20" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_info.svg" style="filter: drop-shadow(1px 1px 0px black);">
                        <!--<i class="fa fa-info-circle" style="filter: drop-shadow(1px 1px 0px black); font-size: 20px;"></i>-->
                        <span>About US</span>
                        <!--<i class="fa fa-arrow-right text-right" style="font-size:12px !important;color:#808488"></i>-->
                    </div>
                </div>
            </div>
        </div>

        <loading :active.sync="bool_fullLoading"></loading>
        <div class="sliding-div form" :class="{ 'is-visible': bool_isProfile }" style="z-index: 1034; " @click.stop>
            <div class="position-relative h-100 overflow-auto">
                <div class="mobile-header">
                    <i class="fa fa-arrow-left" @click="bool_isProfile = false;"></i>
                    <div class="mobile-title"> <h4 class="text-white font-weight-bold mb-0">{{this.getLanguage["PF"]["PI"]}}</h4></div>
                </div>

                <div style="overflow: auto; height: calc(100% - 100px);">
                    <form>
                        <div class="form-section mt-0">
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{getLanguage['AG']['ACCA']}}</div>
                                <span class="agentInfo" v-if="obj_P.LLTS">
                                    <span>{{getLanguage['MEM']['LLT']}}</span>
                                    <span class="ml-2">{{ obj_P.LLTS | moment('DD MMM YYYY HH:mm:ss')}}</span>
                                </span>
                                <span class="agentInfo" v-if="obj_P.LLIP">
                                    <span>{{getLanguage['MEM']['LLIP']}}</span>
                                    <span class="ml-2">  {{ obj_P.LLIP}}</span>
                                </span>

                            </div>
                        </div>

                        <div class="form-section">
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{getLanguage['AG']['UDN']}}</div>
                                <div class="sliding-item-desc">
                                    <input type="text" class="form-control" :placeholder="getLanguage['AG']['UDN']" v-model="obj_P.DN" autocomplete="username">
                                    <span class="ErrMsg">{{ ValidationErrMsg('DN', 'UDN') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{getLanguage['AG']['UE']}}</div>
                                <div class="sliding-item-desc">
                                    <input type="email" class="form-control" :placeholder="getLanguage['AG']['UE']" v-model="obj_P.E" autocomplete="email">
                                    <span class="ErrMsg">{{ ValidationErrMsg('E', 'UE') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{getLanguage['AG']['UPN']}}</div>
                                <div class="sliding-item-desc">
                                    <input type="text" class="form-control" :placeholder="getLanguage['AG']['UPN']" v-model="obj_P.PN" autocomplete="phone">
                                </div>
                            </div>
                        </div>

                        <div class="form-section">
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{getLanguage['AG']['OP']}}</div>
                                <div class="sliding-item-desc">
                                    <CInput :type="isShowOldPassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['AG']['OP']" v-model="obj_P.OP" autocomplete="old-password">
                                        <template #append>
                                            <CButton size="sm"
                                                     type="button"
                                                     color="primary"
                                                     @click="isShowOldPassword = !isShowOldPassword"
                                                     style=" min-width: 40px; z-index: 0; background: #25282d !important; border: none !important;">
                                                <i class="fa fa-eye" v-if="isShowOldPassword"></i>
                                                <i class="fa fa-eye-slash" v-else></i>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ ValidationErrMsg('OP', 'OP') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">
                                    {{getLanguage['AG']['UUP']}}
                                    <span class="text-danger"> ({{getLanguage["AG"]["UPF"]}})</span>
                                </div>
                                <div class="sliding-item-desc">
                                    <CInput :type="isShowPassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['AG']['UUP']" v-model="obj_P.UP" autocomplete="new-password">
                                        <template #append>
                                            <CButton size="sm"
                                                     type="button"
                                                     color="primary"
                                                     @click="isShowPassword = !isShowPassword"
                                                     style=" min-width: 40px; z-index: 0; background: #25282d !important; border: none !important;">
                                                <i class="fa fa-eye" v-if="isShowPassword"></i>
                                                <i class="fa fa-eye-slash" v-else></i>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ ValidationErrMsg('UP', 'UUP') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <div class="sliding-item-title">{{getLanguage['AG']['UCUP']}}</div>
                                <div class="sliding-item-desc">
                                    <CInput :type="isShowConfirmPassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['AG']['UCUP']" v-model="obj_P.CUP" autocomplete="confirm-password">
                                        <template #append>
                                            <CButton size="sm"
                                                     type="button"
                                                     color="primary"
                                                     @click="isShowConfirmPassword = !isShowConfirmPassword"
                                                     style=" min-width: 40px; z-index: 0; background: #25282d !important; border: none !important;">
                                                <i class="fa fa-eye" v-if="isShowConfirmPassword"></i>
                                                <i class="fa fa-eye-slash" v-else></i>
                                            </CButton>
                                        </template>
                                    </CInput>
                                    <span class="ErrMsg">{{ ValidationErrMsg('CUP', 'UCUP') }}</span>
                                </div>
                            </div>
                            <div class="sliding-item">
                                <CButton block color="success" class='font-weight-bold m-0' @shortkey="saveProfile()" @click="saveProfile()" style="font-size: 14px !important;"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "../../modules/GenericHelper.js";
    import { constAccessType, constMenuIcon, constSubAgentType } from '@/modules/Constant.js';
    import { required, sameAs, requiredIf, minLength, email } from "vuelidate/lib/validators";
    import Loading from "vue-loading-overlay";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'

    function validatePassword(value) {
        if (this.obj_P.UP != null && this.obj_P.UP != '') {

            var pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])[A-Za-z\d@#$%^&+=!]{6,32}$/;

            return pattern.test(this.obj_P.UP);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Loading
        },
        name: 'SideMenuBar',
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkMenuAccess', 'checkModuleAccess', 'checkModuleIndex', 'checkSubModuleAccess', 'checkSubModuleIndex']),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion',
                'getPendingAutoDepositPlus'
            ]),
            ...mapGetters('SMBData', [
                'getCurrencySymbol',
                'getSystemBalance',
                'getCreditBalance',
                'getBalanceStatus',
                'getCurrencyCode'
            ]),
            ...mapGetters("Language", [
                "getLanguage",
                "getLanguageOPT",
                "getLanguageIndex",
                "getLangTreeSelect",
                "getLangCode"
            ]),
        },
        data() {
            return {
                minimize: false,
                isMinimize: false,
                hover: false,
                breakpoint: 'md',
                int_OEMId: 0,
                show: false,
                obj_menuTitle: {},
                favMenuList: [],
                //arry_cutmMN: ["AFF","AFFS","AFFL","AFFEL","DASH"],
                constAccessType: constAccessType,
                constMenuIcon: constMenuIcon,
                constSubAgentType: constSubAgentType,
                AutoUpdateTO: null,
                SystemBalance: null,
                CurrencySymbol: null,
                DateTime: this.getTodayDate(),
                timeout: [],
                isOUTMOB: '',
                isFirstLoad: true,

                bool_isProfile: false,
                bool_CV: false, // Check Validation
                bool_fullLoading: false,
                obj_P: {},
                obj_Group: {},

                isShowOldPassword: false,
                isShowPassword: false,
                isShowConfirmPassword: false,
            }
        },
        validations: {
            obj_P: {
                U: { required },
                DN: { required },
                E: { email },
                OP: {
                    required: requiredIf(function (vm) {
                        return vm.UP != '';
                    }),
                },
                UP: {
                    required: requiredIf(function (vm) {
                        return vm.UP != '';
                    }),
                },
                CUP: {
                    minLength: value => !value || minLength(6)(value), validatePassword
                },
            },
        },
        methods: {
            ...mapActions('SMBData', [
                'setCurrencySymbol',
                'setSystemBalance',
                'setCreditBalance',
                'setBalanceStatus',
                'setCurrencyCode'
            ]),
            ...mapActions("Language", ["setLanguage", "setLanguageIndex", "setLangTreeSelect"]),

            toggleSidebar() {
                // Implement logic to toggle sidebar visibility
                if (this.show === 'responsive') {
                    this.show = true; // Show sidebar on click
                } else {
                    this.show = !this.show; // Toggle sidebar visibility
                }
            },

            changeMinimize() {
                this.isMinimize = !this.isMinimize;
                if (this.isMinimize) {
                    this.minimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                } else if (!this.isMinimize) {
                    this.minimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                }
            },
            getFromSystemBalance() {
                var that = this;
                this.getDataApi(`/api/ag/gcag`,
                    function (d, s) {
                        if (s) {
                            that.setCurrencySymbol(d.D.CS);
                            that.setSystemBalance(d.D.SB);
                            that.setCreditBalance(d.D.CB2);
                            that.setBalanceStatus(d.D.BS);
                            that.setCurrencyCode(d.D.ISOC);
                        }
                    });
            },
            AutoUpdate() {
                this.nextUpdate();
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            nextUpdate: function () {
                this.getFromSystemBalance();
            },
            getDate() {
                var self = this;
                self.DateTime = new Date();
                self.timeout[0] = setTimeout(() => {
                    self.getDate();
                }, 1000);
            },
            copyReferralLink: function () {
                var inp = document.createElement('input');
                document.body.appendChild(inp)
                inp.value = this.getUserInfo.SARL;
                inp.select();
                document.execCommand('copy', false);
                inp.remove();

                Vue.notify({
                    group: 'msgNotificationTop',
                    type: 'success',
                    // title: 'Title',
                    text: this.getLanguage['GL']['CPSC'],
                    duration: 2000
                });
            },
            btnChgLang(index) {
                this.setLanguageIndex(index);
                let toLang = this.getLangTreeSelect[this.getLanguageIndex].id;
                this.$root.Language.getLanguage(this, toLang);
                window.localStorage.setItem('lang', toLang);
                this.setLangauge(toLang);
                //this.getSystemAnnouncement();
                //this.currentNumber = 0;
                ////this.startRotation();
                //this.RotateAnnouncement();

                $(".c-sidebar .languageBtn.dropdown, .c-sidebar .languageBtn.dropdown .dropdown-menu").removeClass('show');
            },
            btnClick(path) {
                if (path == "Deposit") {
                    this.$router.push("/D/DDU");
                } else if (path == "Withdraw") {
                    this.$router.push("/W/WDU");
                } else if (path == "Promotion") {
                    this.$router.push("/P/PDU");
                } else if (path == "Member") {
                    this.$router.push("/M/MO");
                } else if (path == "Logout") {
                    this.$fire({
                        //title: this.getLanguage["GL"]["LO"],
                        html: this.utilGetErrorLanguage("GL.LO"),
                        width: '20em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/ggeran_logout-21.png" loading="lazy" width="125">',
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            localStorage.setItem('isMute', 'False');
                            window.location.href = "/app/logout";
                        }
                    });
                }
            },
            setLangauge(toLang) {
                var that = this;
                var path = "f[lc]=" + toLang;
                this.getDataApi(`/api/lang/slis?${path}`,
                    function (d, s) {
                        if (s) {
                        }
                    });
            },

            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_P[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        if (value == "UP") {
                            return this.getLanguage['AG']['IUPF'];
                        }
                        else {
                            return this.getLanguage['PF']['ERRMIN'];
                        }
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.validatePassword != undefined && !validateObj.validatePassword) {
                        return this.getLanguage['AG']['IUPF'];
                    }
                }
            },
            getProfile() {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/agt/g/0`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setProfileData(d.D);
                    }
                });

                this.getDataApi(`/api/sag/g/${this.getUserInfo.AGI}`,
                    function (d, s) {
                        if (s) {
                            that.obj_Group = Object.assign(that.obj_Group, d.D);
                        }
                    });
            },
            setProfileData(data) {
                var agi;
                this.obj_P = data;
                this.obj_P.UP = '';

                agi = (this.obj_P.AT == 4) ? this.obj_P.SAGAGI : this.obj_P.AGI;
                this.obj_P.ATAGI = this.obj_P.AT + "-" + agi;
            },
            saveProfile() {
                this.bool_CV = true;
                this.$v.obj_P.$touch();
                if (!this.$v.obj_P.$error) {
                    this.bool_fullLoading = true;
                    var that = this;
                    this.obj_P.IPF = 1;
                    this.postDataApi(`/api/agt/s`, this.obj_P, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.getProfile();
                            that.$fire({
                                // type: 'error',
                                //title: that.utilGetErrorLanguage("ERR.SS"),
                                html: that.utilGetErrorLanguage("GL.AS"),
                                width: '20em',
                                keydownListenerCapture: true,
                                iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                customClass: {
                                    title: 'afb-alert-title text-success',
                                    content: 'afb-alert-content',
                                    actions: 'afb-alert-action'
                                },
                                didOpen: () => {
                                    const confirmButton = document.querySelector('.afb-alert-action button');
                                    if (confirmButton) {
                                        confirmButton.focus();
                                    }
                                }
                            });
                        }
                    });

                    //this.postDataApi(`/api/sag/s`, { "GN": this.obj_P.DN },function (d, s) {
                    //    if (s) {
                    //    }
                    //});
                }
            },
            clickAbout() {
                if ($(".version").text()) {
                    var that = this;
                    that.$fire({
                        // type: 'error',
                        title: 'GGEarn',
                        html: 'Version ' + $(".version").text(),
                        width: '20em',
                        keydownListenerCapture: true,
                        iconHtml: '<img src="https://media.afb.gg/BackOfficeSiteIco/ggearn-ico2.png" loading="lazy" class="img-fluid" style="filter: drop-shadow(0 0 0.2rem #000);margin-bottom: 10px;width:80px">',
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        },
                        didOpen: () => {
                            const confirmButton = document.querySelector('.afb-alert-action button');
                            if (confirmButton) {
                                confirmButton.focus();
                            }
                        }
                    }).then((result) => {
                        if (result.value == true) {
                           
                        }
                    });;

                }
            }
        },
        watch: {
            $route(to, from) {
                this.show = false;
            }
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            next();
        },
        mounted() {
            this.$root.$on('toggle-sidebar', () => {
                const sidebarOpened = this.show === true || this.show === 'responsive'
                this.show = sidebarOpened ? false : 'responsive'
            })
            this.$root.$on('toggle-sidebar-mobile', () => {
                const sidebarClosed = this.show === 'responsive' || this.show === false
                this.show = sidebarClosed ? true : 'responsive'
            })

            this.getProfile();
            this.getFromSystemBalance();
            this.AutoUpdate();
            this.getDate();
            if (this.$route.path == "/") {
                this.$router.push("/DASH/DBM");
            }
            this.$parent.FisrtMenuItem = "/DASH/DBM";
        },
    }
</script>

<style>
    @keyframes shake {
        0% {
            transform: rotate(0deg);
        }

        25% {
            transform: rotate(5deg);
        }

        50% {
            transform: rotate(0deg);
        }

        75% {
            transform: rotate(-5deg);
        }

        100% {
            transform: rotate(0deg);
        }
    }

    body.marketingApp .c-sidebar .c-sidebar-nav-dropdown-toggle.router-link-active {
        background: linear-gradient(180deg, rgba(255, 167, 0, 1) 10%, rgba(255, 123, 0, 1) 100%) !important;
    }

    body.marketingApp .c-sidebar .c-sidebar-nav-link, body.marketingApp .c-sidebar .c-sidebar-nav-dropdown-toggle {
        background: none !important;
    }

    body.marketingApp .c-sidebar .c-sidebar-nav-dropdown-toggle.router-link-active .menu-Name {
        font-size: 12px !important;
    }

    body.marketingApp .user-profile {
        background: none !important;
    }

    body.marketingApp .c-sidebar-nav-dropdown-toggle {
        padding: 8px 10px 8px 15px !important;
    }

    body.marketingApp .c-sidebar .c-sidebar-nav-dropdown-toggle.router-link-active svg {
        filter: brightness(0) saturate(100%) invert(92%) sepia(93%) saturate(24%) hue-rotate(248deg) brightness(107%) contrast(100%);
    }

    html:not([dir="rtl"]) body.marketingApp .c-sidebar:not(.c-sidebar-right) {
        margin-left: -100%;
    }
    html:not([dir=rtl]) body.marketingApp .c-sidebar.c-sidebar-show:not(.c-sidebar-right), html:not([dir=rtl]) body.marketingApp .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
        margin-left: 0;
    }
    .agentInfo {
        color: #808488;
        display: grid;
        grid-template-columns: 120px auto;
    }

    .agentInfo span:first-child::after {
        content: ":";
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/componentsGGEarn/SideMenu/SideMenuBar.vue